/**
 * Read the persisted edition from the org snapshot AuthContext writes to
 * localStorage under `selected_org`. Route loaders (`beforeLoad`) run before
 * AuthContext is fully mounted, so they read storage directly via this helper.
 *
 * Returns null when:
 *   - storage is missing or empty
 *   - the JSON is malformed
 *   - the `edition` field is absent or holds a value other than the two
 *     recognised editions (e.g., a corrupted entry, a future third edition)
 *
 * Callers should treat `null` as "unknown — fall through to default routing"
 * rather than as a synonym for either edition. The original behaviour of
 * defaulting unknowns to `'professional'` could silently mis-route a personal
 * user into a professional flow.
 */
export function readEditionFromStorage(): 'personal' | 'professional' | null {
  if (typeof window === 'undefined') return null;
  try {
    const raw = window.localStorage.getItem('selected_org');
    if (!raw) return null;
    const parsed = JSON.parse(raw) as { edition?: unknown };
    if (parsed.edition === 'personal') return 'personal';
    if (parsed.edition === 'professional') return 'professional';
    return null;
  } catch {
    return null;
  }
}
